import Vue from 'vue'

import Index from "../components/Index.vue"
import Category from "../components/Category.vue"
import Rank from '../components/Rank.vue'

const routes = [
    { path: '/', redirect: '/fotografie' },
    { path: '/:type', name: 'index', component: Index },
    { path: '/:type/category/:id', name: 'category', component: Category },
    { path: '/:type/rank', name: 'rank', component: Rank },
];

export default routes;
